import { fromJS } from 'immutable'
import {
  STANDARD_COST_PRICE_GET_REQUEST,
  STANDARD_COST_PRICE_GET_SUCCESS,
  STANDARD_COST_PRICE_GET_FAILURE,
  STANDARD_COST_PRICE_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case STANDARD_COST_PRICE_GET_REQUEST:
      return state
        .set('isFetching', true)
    case STANDARD_COST_PRICE_GET_SUCCESS:
      return state
        .set('standardCostPrices', fromJS(action.payload.standardCostPrices))
        .set('isFetching', false)
    case STANDARD_COST_PRICE_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case STANDARD_COST_PRICE_GET_RESET:
      return state
        .delete('standardCostPrices')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standard-cost-price/standard-cost-price-get-reducer.js